// extracted by mini-css-extract-plugin
export default {"totalsWrapper":"ExpenseTotalsRow-module__totalsWrapper___JPfj7","nbView":"ExpenseTotalsRow-module__nbView___qL5EV"};